import Vue from "vue";
import "./cube-ui";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./registerServiceWorker";
import "../src/assets/reset.css";
import "../src/assets/resetVui.scss";
import { processInviteCodeFromUrl } from "@/utils/inviteCode";
import { dealBizToken } from "@/utils/url";
import { initAuth } from "@/utils/http";

Vue.config.productionTip = false;

// 添加全局样式处理备案信息固定定位
const style = document.createElement("style");
style.textContent = `
  /* 为固定定位的备案信息预留空间 */
  .layout .middle:has(.icp-info.fixed-position) {
    padding-bottom: calc(60px + 40px) !important; /* tabbar高度 + 备案信息高度 */
  }
  
  /* 备案信息固定定位时的全局样式调整 */
  #layout:has(.icp-info.fixed-position) .middle {
    padding-bottom: calc(60px + 40px) !important;
  }
  
  /* 确保van-nav-bar固定定位不被其他页面影响 */
  .van-nav-bar {
    position: fixed !important;
    top: 0 !important;
    left: 0 !important;
    right: 0 !important;
    width: 100% !important;
    z-index: 1000 !important;
  }
  
  /* 特别保护Layout内的导航栏 */
  #layout .van-nav-bar {
    position: fixed !important;
    top: 0 !important;
    left: 0 !important;
    right: 0 !important;
    width: 100% !important;
    z-index: 1000 !important;
  }
`;
document.head.appendChild(style);
console.log("app created");

const init = async () => {
  try {
    // 动态导入工具函数
    const inviteCode = await processInviteCodeFromUrl(true); // true表示处理后清理URL参数
    await dealBizToken();
    // 用 refresh_token cookie 尝试静默恢复会话，让 access_token 已过期(cookie 已被浏览器删除)
    // 但 refresh_token 仍有效的老用户不必重新登录；挂载 Vue 树之前完成，
    // 这样 layout/index.vue 的 islogin() 拿到的是恢复后的状态。
    await initAuth();

    if (inviteCode) {
      console.log("发现邀请码并已处理:", inviteCode);
    } else {
      console.log("URL中未发现invite_code参数");
    }
  } catch (error) {
    console.error("处理邀请码时发生错误:", error);
  }
  new Vue({
    router,
    store,
    render: (h) => h(App),
  }).$mount("#app");
};

init();
